// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"bfa73198","453":"2c3abf04"}[chunkId] + ".chunk.js";
};